import { call, put } from 'redux-saga/effects';
import { refresh as swRefresh, getState as getAuthState } from '../../auth/authClient';
import { loginSuccessful, loginFailed } from '../../redux/login/actions';
import { messagesShow } from '../../redux/messages/actions';
import { userGetRequest } from '../../redux/user/actions';
import { AUTH_MODES } from '../../constants/auth';

/**
 * Refresh the Microsoft session through the Service Worker (it holds the
 * Microsoft refresh URL from the login and knows how to renew it).
 */
export function* tryRefreshMicrosoftTokenSaga() {
    try {
        const result = yield call(swRefresh);
        if (!result.ok) {
            throw new Error(result.message || 'Microsoft refresh failed');
        }
        yield put(loginSuccessful());
        yield put(userGetRequest());
        return true;
    } catch (error) {
        console.error('Failed to refresh Microsoft token:', error);
        yield put(loginFailed());
        yield put(messagesShow('azureSessionExpired', 'error'));
        return false;
    }
}

/**
 * On boot, restore a Microsoft session if the Service Worker still holds
 * one (its record persists in IndexedDB across visits; getState refreshes
 * an expired-but-refreshable session transparently).
 */
export function* checkMicrosoftLoginOnStartSaga() {
    try {
        const state = yield call(getAuthState);
        if (state.phase === 'authed' && state.mode === AUTH_MODES.MICROSOFT) {
            yield put(loginSuccessful());
            yield put(userGetRequest());
            return true;
        }
        return false;
    } catch (error) {
        console.error('Error checking Microsoft login on start:', error);
        return false;
    }
}
